import axios from 'axios'
import Cookies from 'js-cookie'
function isTokenInvalidError(error) {
  const { message } = error.response.data
  return message === 'jwt expired'
}
function responseErrorHandler(error) {
  if (isTokenInvalidError(error)) {
  } else if (error.response.status >= 500) {
    alert('伺服器發生錯誤，請聯絡管理人員')
  }
  return Promise.reject(error.response)
}

function responseSuccessHandler(response) {
  return response.data
}

const API = axios.create({
  baseURL: `https://us-central1-backstage-web-e5597.cloudfunctions.net/note`,
  timeout: 1000 * 6,
})

API.interceptors.response.use(responseSuccessHandler, responseErrorHandler)

export default API



// WEBPACK FOOTER //
// ./src/assets/js/libs/FirebaseAPI/Note.js